import tools from '../tools.js';
import Circle from './Circle.js';
import Point from './Point.js';
import Line from './Line.js';
import Animation from './Animation.js';


function Expertise(el) {
    this.el = el;
    this.svgEl = null;
    this.circleEl = null;
    this.pointsEl = null;
    this.circle = null
    this.positions = [];
    this.points = [];
    this.lines = [];
    this.eventAnimId = null;
    this.eventAnims = [];
    this.animId = null;
    this.idleAnimsNb = 3;
    this.currentIdleAnim = 2;
}

Expertise.prototype.init = function() {
    window.expertise = this;
    if(this.el) {
        this.circleWrapperEl = this.el.querySelector('.circle-wrapper');
        if(this.circleWrapperEl) {
            this.svgEl = this.el.querySelector('svg.circle');
            this.circleEl = this.svgEl.querySelector('.main');
            this.pointsEl = this.svgEl.querySelectorAll('.point');
            this.linesEl = this.svgEl.querySelectorAll('.line');
            this.initCircle();
            this.initPoints();
            this.initLines();

            if(tools.isEditMode()) {
                tools.each(this.lines, line => {
                    line.showLine();
                })
            } else {
                setTimeout(() => {
                    this.nextIdleAnim(this.currentIdleAnim);
                }, 2000)
            }
        }
    }
}

Expertise.prototype.initCircle = function() {
    this.circle = new Circle(this.circleEl, this);
    this.circle.init();
}

Expertise.prototype.initPoints = function() {
    if(this.pointsEl) {
        this.positions = this.circle.createPositions(this.pointsEl.length)

        tools.each(this.pointsEl, (el, i) => {
            let point = new Point(el, this);
            point.setInitialPosition(this.positions[i]);
            point.init();
            point.display();
            this.points.push(point);
        })
    }
}

Expertise.prototype.getPoint = function(id='') {
    for(let p = 0; p < this.points.length; p++) {
        let point = this.points[p];
        if(point.getId() === id) {
            return point;
        }
    }
    return null;
}

Expertise.prototype.initLines = function() {
    if(this.linesEl) {
        tools.each(this.linesEl, el => {

            let start = el.getAttribute('data-start');
            let end = el.getAttribute('data-end');
            if(start && end) {
                let startPoint = this.getPoint(start);
                let endPoint = this.getPoint(end);
                if(startPoint && endPoint) {
                    let line = new Line(el, this);
                    line.setPositions(startPoint.getPos(), endPoint.getPos());
                    line.init();
                    this.lines.push(line);
                }
            }
        });
    }
}

Expertise.prototype.triggerEventAnim = function(point) {
    this.eventAnims.push(new Animation(point));
    tools.each(this.lines, l => {
        if(l.hasPoint(point)) {
            let a = new Animation(l);
            this.eventAnims.push(a);
            a.prepare();
        }
    })

    let loop = () => {
        tools.each(this.eventAnims, a => a.animate());
        this.eventAnimId = window.requestAnimationFrame(loop)
    }
    loop();
}

Expertise.prototype.releaseEventAnim = function(point) {
    window.cancelAnimationFrame(this.eventAnimId);
    tools.each(this.eventAnims, a => {
        a.stop()
    })
    this.eventAnims = [];
}

Expertise.prototype.nextIdleAnim = function(i=-1) {
    setTimeout(() => {
        this.currentIdleAnim = i !== -1 ? i : (this.currentIdleAnim + 1) % this.idleAnimsNb;
        this['idleAnimation' + this.currentIdleAnim]();
    }, 500)
}

Expertise.prototype.randomizeArray = function(array, returnNb) {
    let i = array.length;
    let final = [];
    while(0 !== i) {
        let randI = Math.floor(Math.random() * i);
        i -= 1;
        let temp = array[i];
        array[i] = array[randI];
        array[randI] = temp;
    }

    if(returnNb <= -1) {
        final = array
    } else {
        returnNb = returnNb > array.length ? array.length : returnNb;
        for(let j = 0; j < returnNb; j++) {
            final.push(array[j]);
        }
    }
    return final;
}

Expertise.prototype.randomizePoints = function(returnNb= -1) {
    return this.randomizeArray(this.points, returnNb);
}

Expertise.prototype.randomizeLines = function(returnNb = -1) {
    return this.randomizeArray(this.lines, returnNb);
}

Expertise.prototype.idleAnimation0 = function() {
    let animations = [];
    let turns = 0;
    let i1 = Math.floor(Math.random() * this.points.length);
    let i2 = (i1 + Math.floor(this.points.length / 2)) % this.points.length;

    let addToAnimList = toAnimObj => {
        let animation = new Animation(toAnimObj);
        animations.push(animation);
        animation.prepare();
    }

    let prepare = () => {
        turns = 300;

        tools.each(this.randomizePoints(3), p => {
            addToAnimList(p.getPos());
            addToAnimList(p)

            tools.each(this.lines,  l => {
                if (l.hasPoint(p)) {
                    addToAnimList(l);
                }
            })
        })


        this.animId = window.requestAnimationFrame(loop);
    }

    let loop = () => {
        tools.each(animations, a => a.animate());
        turns--
        if(turns > 0) {
            this.animId = window.requestAnimationFrame(loop);
        } else {
            window.cancelAnimationFrame(this.animId);
            tools.each(animations, a => a.stop());
            animations = [];
            // preparePoints();
            this.nextIdleAnim();
        }
    }

    prepare();
}


//lines path
Expertise.prototype.idleAnimation1 = function() {
    let animationsLists = [];
    let turns_def = 33;
    let turns = 0;
    let animArrayIndex = -1;


    let prepare = () => {
        turns = turns_def;
        animArrayIndex = -1;
        let addedLines = [];

        let proceed = true;
        let randLines = this.randomizeLines();
        let l = randLines[0];

        tools.each(randLines, l => {
            let animations = [];
            addedLines.push(l);
            animations.push(new Animation(l));
            animationsLists.push(animations);
        })


        let animations = [];
        tools.each(this.points, p => {
            animations.push(new Animation(p.getPos()));
            animations.push(new Animation(p));
        })

        tools.each(addedLines,  l => {
            animations.push(new Animation(l));
        })
        animationsLists.push(animations);


        this.animId = window.requestAnimationFrame(loop);
    }

    let prepareAnims = (anims) => {
        tools.each(anims, a => {
            a.prepare(4);
        })
        this.animId = window.requestAnimationFrame(loop);
    }

    let loop = () => {
        if(animArrayIndex === -1) {
            animArrayIndex = 0;
            prepareAnims(animationsLists[animArrayIndex])
        }

        tools.each(animationsLists[animArrayIndex], a => a.animate());
        turns--
        if(turns > 0) {
            this.animId = window.requestAnimationFrame(loop);
        } else {
            if(animationsLists.length > animArrayIndex) {
                animArrayIndex ++;
                turns = animArrayIndex === animationsLists.length - 1 ? 300 : turns_def;
                prepareAnims(animationsLists[animArrayIndex]);

            } else {
                window.cancelAnimationFrame(this.animId);
                tools.each(animationsLists, animations => {
                    tools.each(animations, a => a.stop());
                })
                animationsLists = [];
                this.nextIdleAnim();
            }
        }
    }
    prepare();
}

Expertise.prototype.idleAnimation2 = function() {
    let animationsLists = [];
    let turns_def = 100;
    let turns = 0;
    let animArrayIndex = -1;

    let randomizePoints = () => {
        let i = this.points.length;

        while(0 !== i) {
            let randI = Math.floor(Math.random() * i);
            i -= 1;
            let temp = this.points[i];
            this.points[i] = this.points[randI];
            this.points[randI] = temp;
        }

        return this.points;
    }

    let prepare = () => {
        turns = turns_def;
        animArrayIndex = -1;

        animationsLists = [];

        tools.each(randomizePoints(), p => {
            let animations = [];

            animations.push(new Animation(p.getPos()));
            animations.push(new Animation(p));

            tools.each(this.lines,  l => {
                if (l.hasPoint(p)) {
                    animations.push(new Animation(l));
                }
            })
            animationsLists.push(animations);
        })

        this.animId = window.requestAnimationFrame(loop);
    }

    let prepareAnims = (anims) => {
        tools.each(anims, a => {
            a.prepare();
        })

        this.animId = window.requestAnimationFrame(loop);
    }

    let loop = () => {
        if(animArrayIndex === -1) {
            animArrayIndex = 0;
            prepareAnims(animationsLists[animArrayIndex])
        }

        for(let i = 0; i <= animArrayIndex; i++) {
            tools.each(animationsLists[i], a => a.animate());
        }

        turns--

        if(turns > 0) {
            this.animId = window.requestAnimationFrame(loop);
        } else {

            if(animationsLists.length > animArrayIndex) {
                animArrayIndex ++;
                turns = turns_def;
                prepareAnims(animationsLists[animArrayIndex])
            } else {
                window.cancelAnimationFrame(this.animId);
                // tools.each(animationsLists, animations => {
                //     tools.each(animations, a => a.stop());
                // })

                animationsLists = [];
                // preparePoints();
                // this.nextIdleAnim();
                this.idleAnimation7();
            }
        }
    }
    prepare();
}


Expertise.prototype.idleAnimation7 = function() {
    let animationsLists = [];
    let turns_def = 200;
    let turns = 0;
    let animArrayIndex = -1;

    let randomizePoints = () => {
        let i = this.points.length;

        while(0 !== i) {
            let randI = Math.floor(Math.random() * i);
            i -= 1;
            let temp = this.points[i];
            this.points[i] = this.points[randI];
            this.points[randI] = temp;
        }

        return this.points;
    }

    let prepare = () => {
        turns = turns_def;
        animArrayIndex = 0;
        animationsLists = [];
        let count = 0;
        let animations = [];

        tools.each(randomizePoints(), p => {

            animations.push(new Animation(p.getPos()));
            animations.push(new Animation(p));

            tools.each(this.lines,  l => {
                if (l.hasPoint(p)) {
                    animations.push(new Animation(l));
                }
            })

            count++;
            if(count >= 3) {
                animationsLists.push(animations);
                animations = [];
                count = 0;
            }
        })

        if(animations.length > 0) {
            animationsLists.push(animations);
        }
        this.animId = window.requestAnimationFrame(loop);
    }


    let loop = () => {
        tools.each(animationsLists[animArrayIndex], a => a.animate());
        turns--
        if(turns > 0) {
            this.animId = window.requestAnimationFrame(loop);
        } else {
            if(animArrayIndex < animationsLists.length - 1) {
                animArrayIndex ++;
                turns = turns_def;
                this.animId = window.requestAnimationFrame(loop);

            } else {
                window.cancelAnimationFrame(this.animId);
                prepare();
            }
        }
    }
    prepare();
}

Expertise.prototype.idleAnimation4 = function() {
    let animationsLists = [];
    let turns_def = 70;
    let turns = 0;
    let animArrayIndex = -1;


    let prepare = () => {
        turns = turns_def;
        animArrayIndex = -1;
        let addedLines = [];

        let proceed = true;
        let randLines = this.randomizeLines();
        let l = randLines[0];

        while(proceed && addedLines.length < this.lines.length) {
            let animations = [];
            addedLines.push(l);
            animations.push(new Animation(l));
            animationsLists.push(animations);

            proceed = false;
            tools.each(randLines, (line, i) => {
                if(!proceed && addedLines.filter(ll => ll.equals(line)).length === 0 && l.isBefore(line)) {
                    l = line;
                    proceed = true;
                }
            })
        }

        let animations = [];
        tools.each(this.points, p => {
            animations.push(new Animation(p.getPos()));
            animations.push(new Animation(p));
        })
        tools.each(addedLines,  l => {
            animations.push(new Animation(l));
        })
        animationsLists.push(animations);

        this.animId = window.requestAnimationFrame(loop);
    }

    let prepareAnims = (anims) => {
        tools.each(anims, a => {
            a.prepare();
        })
        this.animId = window.requestAnimationFrame(loop);
    }

    let loop = () => {
        if(animArrayIndex === -1) {
            animArrayIndex = 0;
            prepareAnims(animationsLists[animArrayIndex])
        }

        tools.each(animationsLists[animArrayIndex], a => a.animate());
        turns--
        if(turns > 0) {
            this.animId = window.requestAnimationFrame(loop);
        } else {
            if(animationsLists.length > animArrayIndex) {
                animArrayIndex ++;
                turns = animArrayIndex === animationsLists.length - 1 ? 300 : turns_def;
                prepareAnims(animationsLists[animArrayIndex])
            } else {
                window.cancelAnimationFrame(this.animId);
                tools.each(animationsLists, animations => {
                    tools.each(animations, a => a.stop());
                })
                animationsLists = [];
                this.nextIdleAnim();
            }
        }
    }
    prepare();
}

Expertise.prototype.mainAnimLoop = function(anim) {
    if(anim.prepare) {
        anim.prepare();
    }
    let loop = () => {
        anim.iterate()
    }

    this.animId = window.requestAnimationFrame(loop);
}

export default {
    init() {
        let els = document.querySelectorAll('.expertises');
        tools.each(els, el => {
            new Expertise(el).init();
        })
    }
};
